export default __webpack_public_path__ + "static/media/1114.53d0ff22.png";